module.exports = __webpack_public_path__ + "static/media/bistecca-1.cb582464.jpg";